/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measure your WPM and accuracy`)
};

const es_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mide tu WPM y precisión`)
};

const de_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miss deine WPM und Genauigkeit`)
};

const nl_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet je WPM en nauwkeurigheid`)
};

const fr_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesurez votre WPM et votre précision`)
};

const it_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misura il tuo WPM e la precisione`)
};

const pt_br2_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meça seu WPM e precisão`)
};

const pt_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meça o seu WPM e precisão`)
};

const ja_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WPMと正確率を測定`)
};

const zh_typing_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测量您的WPM和准确率`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_nav_main_desc", locale)
	if (locale === "en") return en_typing_nav_main_desc(inputs)
	if (locale === "es") return es_typing_nav_main_desc(inputs)
	if (locale === "de") return de_typing_nav_main_desc(inputs)
	if (locale === "nl") return nl_typing_nav_main_desc(inputs)
	if (locale === "fr") return fr_typing_nav_main_desc(inputs)
	if (locale === "it") return it_typing_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_typing_nav_main_desc(inputs)
	if (locale === "pt") return pt_typing_nav_main_desc(inputs)
	if (locale === "ja") return ja_typing_nav_main_desc(inputs)
	return zh_typing_nav_main_desc(inputs)
};